const ENGINE_BASE = (process.env.REACT_APP_CHIC_ENGINE_ENDPOINT || '').replace(/\/+$/, '');
const AUTH_BASE = `${ENGINE_BASE}/api/v1/auth`;
const API_KEY = process.env.REACT_APP_CHICLOGIC_API_KEY;

const withJson = async (path, options = {}) => {
  const res = await fetch(`${AUTH_BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(API_KEY ? { 'X-Api-Key': API_KEY } : {}),
      ...(options.headers || {}),
    },
    ...options,
  });

  const text = await res.text();
  if (!res.ok) {
    let message = text || 'Request failed';
    try {
      const err = text ? JSON.parse(text) : null;
      message = err?.detail || err?.message || message;
    } catch {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    throw new Error('Failed to parse response from auth service');
  }
};

export async function signup(payload) {
  return withJson('/signup', { body: JSON.stringify(payload) });
}

export async function login(payload) {
  return withJson('/login', { body: JSON.stringify(payload) });
}
